var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeIcon = function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5a.833.833 0 0 1-.833.833H1.333A.834.834 0 0 1 .5 15.5V6.742a.83.83 0 0 1 .322-.659L7.488.898a.83.83 0 0 1 1.024 0l6.666 5.185a.83.83 0 0 1 .322.659zM3.833 11.333V13h8.334v-1.667z"
  })));
};
export default SvgHomeIcon;